module.exports = __webpack_public_path__ + "static/media/domain2.dea3578a.png";